// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"9c3f06ff","268":"96f24ffd","457":"9aa1983c","551":"1ea0d1e5","842":"26c5127b","950":"7f49b22f","980":"97dcb23c"}[chunkId] + ".chunk.js";
};